import { images } from "../../assets/images";
import { TEMA_ROUTE_PATHS } from "../../routes/temaRouteConstants";

export const teachThisTopicFeatured = {
  id: "teach-this-topic",
  title: "Teach this topic",
  description:
    "Upload student queries or handwriting to get instant step-by-step explanations and hints.",
  ctaLabel: "Generate Now",
  href: TEMA_ROUTE_PATHS.TEACH_THIS_TOPIC,
};

export const teachPrepareTools = [
{
  id: "teach-this-topic",
  title: "Teach This Topic",
  description: "Generate lesson flow for any concept",
  iconSrc: images.teach[0],
  href: TEMA_ROUTE_PATHS.TEACH_THIS_TOPIC,
  featured: true
},
{
  id: "explain-differently",
  title: "Explain Differently",
  description: "Analogies and alternative perspectives",
  iconSrc: images.teach[1],
  href: TEMA_ROUTE_PATHS.EXPLAIN_DIFFERENTLY
},
{
  id: "content-simplifier",
  title: "Content Simplifier",
  description: "Break down complex research papers",
  iconSrc: images.teach[2],
  href: TEMA_ROUTE_PATHS.CONTENT_SIMPLIFIER
}];